export default __webpack_public_path__ + "media/images/svg/graphic-bg-3-e8983f8ae71e89e55f8bfb4da770fef2.svg";